import { IAppState } from '../../../AppModulesWrapper';
import { EPaymentStatus } from '../../services/billingPayments';

export function selectDepositAccountPaymentStatus(state: IAppState): EPaymentStatus | null {
  return state.servicePickerWidget.depositAccount.paymentStatus;
}
